import React from 'react';
import PropTypes from 'prop-types';

import Block from 'components/structure/Block/Block';
import Section from 'components/structure/Section';
import OldPageSectionHeading from 'components/structure/OldPageSectionHeading';
import { paddingBuilder } from 'styles/themeUtils';

import { ContractContainer } from './styles/ContractContainer';

function ContractTemplate({ title, children }) {
  return (
    <ContractContainer>
      <OldPageSectionHeading tag="h1">{title}</OldPageSectionHeading>
      <Section minHeight="auto">
        <Block
          blockWidth="100%"
          padding={{
            desktop: paddingBuilder.bottom(5),
          }}
        >
          {children}
        </Block>
      </Section>
    </ContractContainer>
  );
}

ContractTemplate.defaultProps = {
};

ContractTemplate.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
};

export default React.memo(ContractTemplate);
